import {
  SET_CUSTOMERS
} from 'app/actions/types';

import {
  getCustomers as getCustomersSvc
} from 'app/services/customers';

export const getCustomers = params => async dispatch => {
  let customers = await getCustomersSvc(params);

  if (customers) {
    dispatch({
      type: SET_CUSTOMERS,
      payload: customers.params
    });
  }

  return customers;
}

export const setCustomerParams = params => async dispatch => {
  dispatch({
    type: SET_CUSTOMERS,
    payload: params
  });
}

